import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
import VueJwtDecode from 'vue-jwt-decode'
import httpClient from '@/utilities/service/httpClient'
import TokenManager from '@/utilities/auth/azure/TokenManager'
import AxiosService from '@/utilities/service/AxiosService'
// @ts-ignore
import WeatherPlugin from './plugins/weather'
// @ts-ignore
import * as VueGoogleMaps from './plugins/googleMap'
// @ts-ignore
import * as OptimoRoute from './plugins/optimoRoute'
// @ts-ignore
import * as PostCode from './plugins/postcode'
// @ts-ignore
import * as Azure from './plugins/azure'
// @ts-ignore
import App from './App.vue'
import { sync } from 'vuex-router-sync'
// @ts-ignore
import router from './router/router'
// @ts-ignore
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
// @ts-ignore
import vuetify from './plugins/vuetify'
// @ts-ignore
import i18n from './i18n'

import ReactWrapper from '@/components/ReactWrapper.vue'

Vue.config.productionTip = false

Vue.component('ReactWrapper', ReactWrapper)

sync(store, router)

const beforeRouterInitialize = (router: Router): Router => {
  // @ts-ignore
  const app = new Vue({ Azure })

  const axiosService = new AxiosService(httpClient, VueJwtDecode)
  const tokenManager = new TokenManager(app.$azure, localStorage)

  axiosService.refreshTokenWatcher(app.$azure, tokenManager, store)
  axiosService.setResponseInspector(store)
  axiosService.displayResponseMessages(store)

  return router
}

new Vue({
  router: beforeRouterInitialize(router),
  store,
  vuetify,
  // @ts-ignore
  i18n,
  // @ts-ignore
  VueCookies,
  VueGoogleMaps,
  OptimoRoute,
  PostCode,
  Azure,
  WeatherPlugin,
  render: h => h(App),
}).$mount('#app')
